/**
 * @param {string} status
 */
export function chairStatusLabel(status) {
  switch (status) {
    case 'occupied':
      return 'Live'
    case 'waiting':
      return 'Waiting'
    case 'turnover':
      return 'Prep'
    default:
      return 'Ready'
  }
}

/**
 * @param {number | null | undefined} minutes
 */
export function formatRemainingLabel(minutes) {
  if (minutes === null || minutes === undefined) {
    return '—'
  }

  return `${minutes} min left`
}

/**
 * @param {import('@/types/api').ChairBoardRoom} room
 */
export function primaryChairAction(room) {
  if (!room.session_id) {
    return null
  }

  switch (room.session_status) {
    case 'waiting':
      return { type: 'start', label: 'Start service' }
    case 'in_chair':
      return { type: 'complete', label: 'Complete' }
    case 'turnover':
      return { type: 'finish_turnover', label: 'Mark ready' }
    default:
      return null
  }
}

const STATUS_STYLES = {
  occupied: {
    badge: 'bg-primary text-primary-foreground',
    card: 'from-primary/[0.06] to-card',
    bar: 'from-primary via-secondary to-gold',
  },
  waiting: {
    badge: 'bg-sky-500 text-white',
    card: 'from-sky-50/80 to-card',
    bar: 'from-sky-400 to-sky-500',
  },
  available: {
    badge: 'bg-emerald-500 text-white',
    card: 'from-emerald-50/80 to-white',
    bar: 'from-emerald-400 to-emerald-500',
  },
  turnover: {
    badge: 'bg-amber-500 text-white',
    card: 'from-amber-50/70 to-card',
    bar: 'from-amber-400 to-amber-500',
  },
}

/**
 * @param {string} status
 */
export function chairStatusStyles(status) {
  return STATUS_STYLES[status] ?? STATUS_STYLES.available
}
